import * as React from 'react';
import cn from 'classnames';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';
import * as Styles from '../Icon.module.scss';

export const FlagIcon = ({ fill = 'offBlack', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(fill && Styles[fill], Styles.fill);

    return (
        <svg
            data-testid="flag-icon"
            xmlns="http://www.w3.org/2000/svg"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M4.02759 13.7716V17.4997H2.5V3.33301H17.1175C17.1844 3.3329 17.2502 3.34997 17.3083 3.38251C17.3663 3.41504 17.4146 3.46191 17.4482 3.5184C17.4819 3.57489 17.4997 3.63902 17.5 3.70437C17.5003 3.76972 17.4829 3.83398 17.4497 3.89073L14.7207 8.55231L17.4497 13.2139C17.4829 13.2706 17.5003 13.3349 17.5 13.4002C17.4997 13.4656 17.4819 13.5297 17.4482 13.5862C17.4146 13.6427 17.3663 13.6896 17.3083 13.7221C17.2502 13.7546 17.1844 13.7717 17.1175 13.7716H4.02759ZM4.02759 4.82424V12.2804H15.1438L12.9609 8.55231L15.1438 4.82424H4.02759Z"
                className={fillStyles}
            />
        </svg>
    );
};
